import useClientConfig from 'config/clients/useClientConfig'
import { createBrowserHistory } from 'history'

//const history = createBrowserHistory()
const { getPublicUrl } = useClientConfig()
const options = { basename: getPublicUrl() }
const history = createBrowserHistory(options)

export default history
